import { Subject } from 'rxjs';
const routerChangedSubject = new Subject();
export default routerChangedSubject;
